import _debounce from "lodash/debounce"

export function handleHashScroll() {
    if (window.location.hash === "#video-tour-durch-das-portal") {
        setTimeout(() => {
            const element = document.getElementById(window.location.hash.substring(1))
            if (element) element.scrollIntoView(true)
        }, 2000)
    }
}

export function handleScrollEvents() {
    window.addEventListener(
        "scroll",
        _debounce(() => {
            document.body.classList.toggle("scrolled", window.scrollY > 50)
        }, 50),
        {passive: true}
    )
}
